
import { defineComponent } from 'vue'
import ObjectTabRaw from '@/components/ObjectTabRaw.vue'
import TagTabRaw from '@/components/Tag.vue'

enum TabId {
  Network = 'Network',
  Gateways = 'Gateways',
  IntelligentThings = 'IntelligentThings',
  Tags = 'Tags'
}

interface TabOption {
  id: TabId
  label: string
}

export default defineComponent({
  components: { ObjectTabRaw, TagTabRaw },
  props: ['myinfos', 'mytagsinfo', 'myitsinfo', 'mygatewaysinfo', 'itsLoading'],
  data() {
    return {
      selectedTab: TabId.IntelligentThings
    }
  },
  computed: {
    tabOptions(): TabOption[] {
      return [
        {
          id: TabId.Network,
          label: 'Réseaux'
        },
        {
          id: TabId.Gateways,
          label: 'Passerelles'
        },
        {
          id: TabId.IntelligentThings,
          label: 'Objets'
        },
        {
          id: TabId.Tags,
          label: 'Tags'
        }
      ]
    },
    tabContent() {
      switch (this.selectedTab) {
        case TabId.IntelligentThings:
          return this.myitsinfo
        case TabId.Tags:
          return this.mytagsinfo
        case TabId.Gateways:
          return this.mygatewaysinfo
        case TabId.Network:
          return []
        default:
          return []
      }
    }
  },
  methods: {
    changeTab(tab: TabId) {
      this.selectedTab = tab
    }
  }
})
